import { Joi } from 'app-webtech-core/schemas';
import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { CLOSE_MENU } from './types';

const setMenuPayloadSchema = Joi.any().optional();

const closeMenuAction = actionCreator(CLOSE_MENU, setMenuPayloadSchema);

export const layoutCloseMenuThunkAction = () => (dispatch) => {
  dispatch(closeMenuAction());
};
